import {Component, OnInit, Output, Injectable, HostListener, ViewChild} from '@angular/core';
import {LeadService} from '../services/lead.service';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {LeadsAdvanceSearch} from '../../housekeeping/models/data-model';
import {GlobalVariable} from '../../../config';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {Router, ActivatedRoute, Params} from '@angular/router';
import * as moment from 'moment';

declare var jQuery: any;
import {DatePipe} from '@angular/common';
import {ExportAvailability} from '../../../config';

@Component({
  selector: 'app-lead',
  templateUrl: '../views/lead.component.html',
  styleUrls: ['../css/lead.component.css'],
  providers: [DatePipe]
})
export class LeadComponent implements OnInit {
  public BaseUrl: string = GlobalVariable.FORDAPIEndPointURL;
  public leadList: any = [];
  public websites: any = [];
  public websiteSelected: any = [];
  public campaignSelected: any = [];
  public campaignNames: any = [];
  public campaignNameSelected;
  public userId: string;
  public limit: number = 10;
  public offset: number = 0;
  public searchText: string;
  public showBack: boolean = false;
  public showNext: boolean = false;
  public showLeadTooltip: boolean = false;
  public showTooltipLeads: boolean = true;
  public showAdvance: boolean = false;
  public showAdvanceLink: boolean = true;
  public noData: boolean = false;
  public advancesearchfields = new LeadsAdvanceSearch(null, null, "", [], [], null, [], [], null, [], [], 0, 10, null, null, true, "", "", [], [], "", [], false);
  public statusList: any;
  public priorityList: any;
  public leadSourceList: any;
  public finalExportData: any = [];
  public lastname: any = "";
  public showsubmission: boolean = false;
  public showsubmissionrange: boolean = false;
  public roleId: string;
  public advanceSearchList: boolean = false;
  public advanceOffset: number = 0;
  public enablePagination: boolean = true;
  public userTZ = '';
  public datePickerClick = false;
  public headerLeadsList: any = [];
  public normalSearch: boolean = false;
  public basicOffset: number = 0;
  public headerLeadsListlength = 0;
  public column: string = "";
  public sort: string = "ASC";
  public emailFlag: string;
  public direction: boolean = false;
  public list: boolean = false;
  public normalSearchValues: any = {lastname: "", orderBy: "", sortBy: "", direction: false};
  public leadListValues: any = {orderBy: "", sortBy: "", direction: ""};
  public EXPORT = ExportAvailability.export;
  public hideLeadImport: boolean = false;
  public eventValues = [];
  public countryWithCodeList: any = [];
  public leadExportStatus = true;
  public $j = jQuery.noConflict();
  public VOIWithMakeModel: any = [];
  public last7Count: number;
  public p: number=parseInt(sessionStorage.getItem('pageNo'));
  //dropdown values
  public statusSelected: any = [{id: 2, statusType: "New"}, {
    id: 3,
    statusType: "Pending"
  }];
  public eventIdSelected: any = [];
  public countrySelected: any = [];
  public leadSelected: any = [];
  public VOISelected: any = [];
  public RDSelected: string = ""
  public VPSelected: any = [];
  public regionSelected: any = []
  //Boolean
  public isStatusAll: boolean = false;
  public isEventIdAll: boolean = false;
  public isCountryAll: boolean = false;
  public isLeadAll: boolean = false;
  public isVOIAll: boolean = false;
  public isVPAll: boolean = false;
  public isWebsiteAll: boolean = false;
  public isCampaignAll: boolean = false;
  public isRegionAll: boolean = false;
  public pageExist: any;

  //dropdown count
  public statusCount: number = 0;
  public eventIdCount: number = 0;
  public countryCount: number = 0;
  public leadCount: number = 0;
  public VOICount: number = 0;
  public regionCount: number = 0;
  public WebsiteCount: number = 0;
  public campaignCount: number = 0;
  public VPCount: number = 0;
  public RDCount: number = 0;
  //count max values
  public statusIndex: any = [];
  public eventIdIndex: any = [];
  public countryIndex: any = [];
  public leadIndex: any = [];
  public VOIIndex: any = [];
  public regionIndex: any = []
  public VPIndex: any = [];
  public websiteIndex: any = [];
  public campaignIndex: any = [];
  public RDIndex: any = [];

  //storing value to filter from criteria
  public filterStatus: any = [{id: 1, statusType: "New"}, {id: 2, statusType: "Open"}, {
    id: 3,
    statusType: "Pending"
  }];
  public filterEventId: any = [];
  public filterCountry: any = [];
  public filterLead: any = [];
  public filterVOI: any = [];
  public filterRegion: any = [];
  public filterVP: any = [];
  public filterWebsite: any = [];
  public filterCampaign: any = [];

  //For session storage
  public selectOrDeselect = {
    'isStatusAll': false,
    'isEventIdAll': false,
    'isCountryAll': false,
    'isLeadAll': false,
    'isVOIAll': false,
    'isVPAll': false,
    'isWebsiteAll': false,
    'isCampaignAll': false,
    'isRegionAll': false,
  };

  //Settings for dropdowns
  public statusSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'statusType',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public eventSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'idWithDescription',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public leadSourceSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'sourceType',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public countrySettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'namecode',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public VOISettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'makeModel',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public regionSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'codeDescription',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public VPSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'description',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public RDSettings = {
    allowSearchFilter: false,
    singleSelection: true,
    idField: 'id',
    textField: 'website',
//    selectAllText: 'Select All',
//    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,

  }
  public websiteSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'website',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true

  };
  public campaignSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'campaign',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true

  };

  public showCriteria: any = [];

  public totalRecords = 0;
  public pageSize = 10;

  submissionDate: Date;
  fromDate: Date;
  toDate: Date;
//    storeSubmission: string
//    storeFromDate: string
//    storeToDate: string

  @ViewChild('fromDateCal') datePicker1;
  @ViewChild('toDateCal') datePicker2;
  @ViewChild('searchForm') searchFormObj: any;
  //    @ViewChild('searchForm') searchForm;
  public vehiclePurposeList: any;
  public RelativeDate = ["Last 7 Days", "Last 30 Days", "Last 60 Days"]
  public region: any = []

  constructor(public _dataService: GlobalDataService, public _router: Router, public _leadService: LeadService, private datePipe: DatePipe, private activatedRoute: ActivatedRoute) {
    this.emailFlag = this.activatedRoute.snapshot.paramMap.get('email');
  }

  ngOnInit() {
    this.limit = this.pageSize;
    if (sessionStorage.getItem("pageLimit") !== null) {
      this.limit = Number(sessionStorage.getItem("pageLimit"));
      this.pageSize = Number(sessionStorage.getItem("pageLimit"))
    }
    if (!this.EXPORT) {
      document.getElementById("leadsExport").classList.add('hidden');
    }
    //this.$j('[data-toggle="tooltip"]').tooltip();
    if (sessionStorage.getItem('roleId') == 'SYSADM' && sessionStorage.getItem('roleId') == 'REGIONAL') {
      this.hideLeadImport = true;
    }
    this.userTZ = this._dataService.USER_TZ;
    this.userId = sessionStorage.getItem('userId');
    this.roleId = sessionStorage.getItem('roleId');
    this.prepareLeadTable();
    const path = this._dataService.getPreviousUrl();
    if (!path.includes('/leads/detail')) {
      this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
      this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
      if (this.advanceOffset > 0) {
        this.showBack = true;
      }
      this.advancesearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));
      if (this.advancesearchfields) {
        this.statusSelected = this.advancesearchfields.statusIds;
        this.eventIdSelected = this.advancesearchfields.eventIds;
        this.leadSelected = this.advancesearchfields.sourceIds;
        this.countrySelected = this.advancesearchfields.countryIds;
        this.VOISelected = this.advancesearchfields.vehicleOfInterestIds;
        this.regionSelected = this.advancesearchfields.regionIds;
        this.VPSelected = this.advancesearchfields.vehiclePurposeIds;
        if (this.advancesearchfields.submitionDate != "" && this.advancesearchfields.submitionDate != null) {
          this.submissionDate = this.getUtcDate(this.advancesearchfields.submitionDate);
          this.onSelectSubmission(this.submissionDate)
        }
        if (this.advancesearchfields.fromDate != "" && this.advancesearchfields.fromDate != null) {
          //  this.showsubmission = false;
          //  this.showsubmissionrange = true;
          this.fromDate = this.getUtcDate(this.advancesearchfields.fromDate);
          this.onSelectFrom(this.fromDate)
        }
        if (this.advancesearchfields.toDate != "" && this.advancesearchfields.toDate != null) {
          //  this.showsubmission = false;
          //  this.showsubmissionrange = true;
          this.toDate = this.getUtcDate(this.advancesearchfields.toDate);
          this.onSelectTo(this.toDate)
        }
        this.lastname = this.advancesearchfields.lastName;
        this.sort = this.advancesearchfields.sortBy;
        this.column = this.advancesearchfields.orderBy;
      } else {
        this.advancesearchfields = new LeadsAdvanceSearch(null, null, "", [], [], null, [], [], null, [], [], 0, 10, null, null, true, "", "", [], [], "", [], false);
        this.statusSelected = [{id: 2, statusType: "New"}, {id: 3, statusType: "Pending"}];
      }
      if (this.emailFlag) {
        this.initEmail();
      }
      this.advanceSearch();

      // this.getLeadList();
    }
    if (path.includes('/leads/detail')) {
      if (sessionStorage.getItem("normalSearch") !== null) {
        this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
        this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
        if (this.advanceOffset > 0) {
          this.showBack = true;
        }
        this.selectOrDeselect = JSON.parse(sessionStorage.getItem("selectOrDeselect"));
        if (this.selectOrDeselect) {
          //To prevent select all and to send empty array
          this.isStatusAll = this.selectOrDeselect.isStatusAll;
          this.isEventIdAll = this.selectOrDeselect.isEventIdAll;
          this.isCountryAll = this.selectOrDeselect.isCountryAll;
          this.isLeadAll = this.selectOrDeselect.isLeadAll;
          this.isVOIAll = this.selectOrDeselect.isVOIAll;
          this.isRegionAll = this.selectOrDeselect.isRegionAll;
          this.isVPAll = this.selectOrDeselect.isVPAll;
          this.isWebsiteAll = this.selectOrDeselect.isWebsiteAll;
        }
        this.advancesearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));
        if (this.advancesearchfields) {
          this.statusSelected = this.advancesearchfields.statusIds;
          this.eventIdSelected = this.advancesearchfields.eventIds;
          this.leadSelected = this.advancesearchfields.sourceIds;
          this.countrySelected = this.advancesearchfields.countryIds;
          this.VOISelected = this.advancesearchfields.vehicleOfInterestIds;
          this.regionSelected = this.advancesearchfields.regionIds
          this.VPSelected = this.advancesearchfields.vehiclePurposeIds;
          this.websiteSelected = this.advancesearchfields.websites;
          this.campaignSelected = this.advancesearchfields.campaignNames;
          if (this.advancesearchfields.submitionDate != "" && this.advancesearchfields.submitionDate != null) {
            this.submissionDate = this.getUtcDate(this.advancesearchfields.submitionDate);
            this.onSelectSubmission(this.submissionDate)
          }
          if (this.advancesearchfields.fromDate != "" && this.advancesearchfields.fromDate != null) {
            //  this.showsubmission = false;
            //  this.showsubmissionrange = true;
            this.fromDate = this.getUtcDate(this.advancesearchfields.fromDate);
            this.onSelectFrom(this.fromDate)
          }
          if (this.advancesearchfields.toDate != "" && this.advancesearchfields.toDate != null) {
            //  this.showsubmission = false;
            //  this.showsubmissionrange = true;
            this.toDate = this.getUtcDate(this.advancesearchfields.toDate);
            this.onSelectTo(this.toDate)
          }

          this.lastname = this.advancesearchfields.lastName;
          this.sort = this.advancesearchfields.sortBy;
          this.column = this.advancesearchfields.orderBy;
        } else {
          this.advancesearchfields = new LeadsAdvanceSearch(null, null, "", [], [], null, [], [], null, [], [], 0, 10, null, null, true, "", "", [], [], "", [], false);
          this.statusSelected = [{id: 2, statusType: "New"}, {id: 3, statusType: "Pending"}];
        }
        this.advanceSearch();

//        this.basicOffset = Number(sessionStorage.getItem("normalSearch"));
//        if (this.basicOffset > 0) {
//          this.showBack = true;
//        }
//        this.normalSearchValues = JSON.parse(sessionStorage.getItem("normalSearchValues"));
//        if (this.normalSearchValues != null) {
//          this.lastname = this.normalSearchValues.lastname;
//          this.column = this.normalSearchValues.orderBy;
//          this.sort = this.normalSearchValues.sortBy;
//          this.direction = this.normalSearchValues.direction;
//        }
//        this.basicSearch();
      } else if (sessionStorage.getItem("advanceSearch") !== null) {
        this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
        this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
        if (this.advanceOffset > 0) {
          this.showBack = true;
        }
        this.selectOrDeselect = JSON.parse(sessionStorage.getItem("selectOrDeselect"));

        //To prevent select all and to send empty array
        this.isStatusAll = this.selectOrDeselect.isStatusAll;
        this.isEventIdAll = this.selectOrDeselect.isEventIdAll;
        this.isCountryAll = this.selectOrDeselect.isCountryAll;
        this.isLeadAll = this.selectOrDeselect.isLeadAll;
        this.isVOIAll = this.selectOrDeselect.isVOIAll;
        this.isRegionAll = this.selectOrDeselect.isRegionAll;
        this.isVPAll = this.selectOrDeselect.isVPAll;
        this.isWebsiteAll = this.selectOrDeselect.isWebsiteAll;
        this.isCampaignAll = this.selectOrDeselect.isCampaignAll;

        this.advancesearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));
        this.statusSelected = this.advancesearchfields.statusIds;
        this.eventIdSelected = this.advancesearchfields.eventIds;
        this.leadSelected = this.advancesearchfields.sourceIds;
        this.countrySelected = this.advancesearchfields.countryIds;
        this.VOISelected = this.advancesearchfields.vehicleOfInterestIds;
        this.regionSelected = this.advancesearchfields.regionIds;
        this.VPSelected = this.advancesearchfields.vehiclePurposeIds;
        this.websiteSelected = this.advancesearchfields.websites;
        this.campaignSelected = this.advancesearchfields.campaignNames;
        if (this.advancesearchfields.submitionDate != "" && this.advancesearchfields.submitionDate != null) {
          this.submissionDate = this.getUtcDate(this.advancesearchfields.submitionDate);
          this.onSelectSubmission(this.submissionDate)
        }
        if (this.advancesearchfields.fromDate != "" && this.advancesearchfields.fromDate != null) {
          //  this.showsubmission = false;
          //  this.showsubmissionrange = true;
          this.fromDate = this.getUtcDate(this.advancesearchfields.fromDate);
          this.onSelectFrom(this.fromDate)
        }
        if (this.advancesearchfields.toDate != "" && this.advancesearchfields.toDate != null) {
          // this.showsubmission = false;
          // this.showsubmissionrange = true;
          this.toDate = this.getUtcDate(this.advancesearchfields.toDate);
          this.onSelectTo(this.toDate)
        }

        this.lastname = this.advancesearchfields.lastName;
        this.sort = this.advancesearchfields.sortBy;
        this.column = this.advancesearchfields.orderBy;
        this.advanceSearch();
      } else if (sessionStorage.getItem("leadList") !== null) {
        this.offset = Number(sessionStorage.getItem("leadList"));
        if (this.offset > 0) {
          this.showBack = true;
        }
        this.leadListValues = JSON.parse(sessionStorage.getItem("leadListValues"));
        this.sort = this.leadListValues.sortBy;
        this.column = this.leadListValues.orderBy;
        this.direction = this.leadListValues.direction;
        this.getLeadList();
      } else {
        this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
        this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
        if (this.advanceOffset > 0) {
          this.showBack = true;
        }
        this.selectOrDeselect = JSON.parse(sessionStorage.getItem("selectOrDeselect"));
        if (this.selectOrDeselect) {
          //To prevent select all and to send empty array
          this.isStatusAll = this.selectOrDeselect.isStatusAll;
          this.isEventIdAll = this.selectOrDeselect.isEventIdAll;
          this.isCountryAll = this.selectOrDeselect.isCountryAll;
          this.isLeadAll = this.selectOrDeselect.isLeadAll;
          this.isVOIAll = this.selectOrDeselect.isVOIAll;
          this.isRegionAll = this.selectOrDeselect.isRegionAll;
          this.isVPAll = this.selectOrDeselect.isVPAll;
          this.isWebsiteAll = this.selectOrDeselect.isWebsiteAll;
          this.isCampaignAll = this.selectOrDeselect.isCampaignAll;
        }
        this.advancesearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));
        if (this.advancesearchfields) {
          this.statusSelected = this.advancesearchfields.statusIds;
          this.eventIdSelected = this.advancesearchfields.eventIds;
          this.leadSelected = this.advancesearchfields.sourceIds;
          this.countrySelected = this.advancesearchfields.countryIds;
          this.VOISelected = this.advancesearchfields.vehicleOfInterestIds;
          this.regionSelected = this.advancesearchfields.regionIds;
          this.VPSelected = this.advancesearchfields.vehiclePurposeIds;
          this.websiteSelected = this.advancesearchfields.websites;
          this.campaignSelected = this.advancesearchfields.campaignNames;

          if (this.advancesearchfields.submitionDate != "" && this.advancesearchfields.submitionDate != null) {
            this.submissionDate = this.getUtcDate(this.advancesearchfields.submitionDate);
            this.onSelectSubmission(this.submissionDate)
          }
          if (this.advancesearchfields.fromDate != "" && this.advancesearchfields.fromDate != null) {
            //   this.showsubmission = false;
            //   this.showsubmissionrange = true;
            this.fromDate = this.getUtcDate(this.advancesearchfields.fromDate);
            this.onSelectFrom(this.fromDate)
          }
          if (this.advancesearchfields.toDate != "" && this.advancesearchfields.toDate != null) {
            //  this.showsubmission = false;
            //  this.showsubmissionrange = true;
            this.toDate = this.getUtcDate(this.advancesearchfields.toDate);
            this.onSelectTo(this.toDate)
          }

          this.lastname = this.advancesearchfields.lastName;
          this.sort = this.advancesearchfields.sortBy;
          this.column = this.advancesearchfields.orderBy;
        } else {
          this.advancesearchfields = new LeadsAdvanceSearch(null, null, "", [], [], null, [], [], null, [], [], 0, 10, null, null, true, "", "", [], [], "", [], false);
          this.statusSelected = [{id: 2, statusType: "New"}, {id: 3, statusType: "Pending"}];
        }
        this.advanceSearch();
        //       this.getLeadList();
      }
    }
    this.getStatusList();
    this.getLeadSourceList();
    this.getCountryList();
    this.getEventId();
    this.getVOIValues();

    this.getVehiclePurposeList();
    this.getWebsiteAndCampaignNameList();
    this.getRegionList();
    this.getLast7Count();
  }

  changeShowStatus() {
    this.showTooltipLeads = !this.showTooltipLeads;
  }

  /**
   * @author Pradeep
   * @description get vehicle purpose list
   */
  getVehiclePurposeList() {
    this._leadService.getVehiclePurposeList(this.userId, (result) => {
      this.vehiclePurposeList = result;
    });
  }

  /**
   * @author Nagendra
   * @description Preparing Lead List data
   */
  getLeadList() {
    this.leadList = [];
    this.list = true;
    this.advanceSearchList = false;
    this.normalSearch = false;
    this.basicOffset = 0;
    this.advanceOffset = 0;
    this.getLast7Count();
    this._leadService.getLeadList(this.userId, this.offset, this.limit, this.column, this.sort, (result) => {
      this.leadList = result.beans;
      if (this.offset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }
      if (this.leadList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.leadList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.leadList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.leadList.length > 10) {

        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }
      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    });

  }

  /**
   * @author Nagendra
   * @description To get row and label fields data
   */
  prepareLeadTable() {
    this.headerLeadsList = [];
    this._leadService.getUserPreference(this.userId, (result) => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        this.headerLeadsList = result;
        this.headerLeadsListlength = result.length;
      }
      //If no preference set go to default preferences
      else {
        this.getDefaultPreferences();
      }

    })
  }

  /**
   * @author Nagendra
   * @description get default preferences
   */
  getDefaultPreferences() {
    this._leadService.getviewSettings(result => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        result.forEach(setting => {
          if (setting.isDefult == true) {
            this.headerLeadsList.push({setting});
          }
        })

      }
      this.headerLeadsListlength = result.length;
    });
  }

  /**
   *
   */
  convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("UTC", {timeZone: tzString}));
  }
  getUtcDate(std){
    //console.log(std)
    var date = new Date(std)
    //console.log(date)
    var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    //console.log(new Date(date.getTime() + userTimezoneOffset))
    return new Date(date.getTime() + userTimezoneOffset);
  }
  getFieldConvertedValue (leads,property) {
    //console.log(property)
    //console.log(leads[property]);
    if (property == "dateEntered" ){
      return this.convertTZ(leads[property],this.userTZ)
    }
    if (property == "dateClosed" ){
      return this.convertTZ(leads[property],this.userTZ)
    }
    if (property == "submissionDate" ){
      return this.convertTZ(leads[property],this.userTZ)
    }
    if (property == "voi_options_c" ){
      return "<a href='"+leads[property]+"'>Click me !</a>"
    }
    return leads[property];
    /*(rowlabel.setting.property | slice:5) == "dateEntered" ?
      (leads[rowlabel.setting.property | slice:5] | date: 'MM/dd/yyyy hh:mm:ss':userTZ) :
    (rowlabel.setting.property | slice:5) == "dateClosed" ?
      (leads[rowlabel.setting.property | slice:5] | date: 'MM/dd/yyyy hh:mm:ss':userTZ) :
    (rowlabel.setting.property | slice:5) == "dateClosed" ?
      (leads[rowlabel.setting.property | slice:5] | date: 'MM/dd/yyyy hh:mm:ss':userTZ) :
    ((rowlabel.setting.property | slice:5) == "submissionDate" ?
      (leads[rowlabel.setting.property | slice:5] | date: 'MM/dd/yyyy hh:mm:ss':userTZ) :
    (leads[rowlabel.setting.property | slice:5]))*/
  }
  /**
   * @author Nagendra
   * @description Get Previous Page
   */
  GoBack() {
    this.offset -= 10;
    if (this.offset == 0) {
      this.showBack = false;
      this.noData = false;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset -= 10;
      if (this.advanceOffset == 0) {
        this.showBack = false;
        this.noData = false;
      } else if (this.advanceOffset > 0) {
        this.showNext = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset -= 10;
      if (this.basicOffset == 0) {
        this.showBack = false;
        this.noData = false;
      }
      if (this.basicOffset > 0) {
        this.showNext = true;
      }
      this.basicSearch();
    } else {
      this.getLeadList();
    }

  }

  /**
   * @author Nagendra
   * @description Get Next Page
   */
  nextPage() {
    this.showBack = false;
    this.offset += 10;
    if (this.offset > 0) {
      this.showBack = true;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset += 10;
      if (this.advanceOffset > 0) {
        this.showBack = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset += 10;
      if (this.basicOffset > 0) {
        this.showBack = true;
      }
      this.basicSearch();
    } else {
      this.getLeadList();
    }
  }

  /**
   * @author Pradeep
   * @description showing Advance search page
   */
  showadvanceSearch(value) {

    this.showAdvance = value;
    if (this.showAdvance) {
      this.showBack = false;
      this.showAdvanceLink = false
    } else {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset = 0;
      this.lastname = "";
      this.advancesearchfields.firstName = ""
      this.advancesearchfields.submitionDate = null;
      this.showsubmission = false;
      this.showsubmissionrange = false;
      this.showAdvanceLink = true;
      this.showCriteria = [];
      this.getLeadList();
    }
  }
  checkHotLead(lead){
    var d1 = Date.parse(lead.submissionDate)
    var d2 = new Date()
    var time = 30 * 60 * 60 * 24 * 1000
    var diff = d2.getTime()-d1
    return diff < time
  }
  /**
   * @author Pradeep
   * @description get status list
   */
  getStatusList() {
    this._leadService.getStatusList(this.userId, (result) => {
      //this.statusList = result;
      this.statusList = [result[2], result[0], result[1]];
    });
  }

  /**
   * @author Pradeep
   * @description lead source list
   */
  getLeadSourceList() {
    this._leadService.getLeadSourceList(this.userId, (result) => {
      this.leadSourceList = result;
    });
  }

  /**
   * @author Pradeep
   * @description get country list
   */
  getCountryList() {
    this._leadService.getCountryList(this.userId, (result) => {
      result.forEach(obj => {
        this.countryWithCodeList.push({
          id: obj.id,
          name: obj.name,
          code: obj.code,
          namecode: obj.code + '(' + obj.name + ')'
        })
      })
    });
  }

  /**
   * @author Nagendra
   * @description Search by lastName
   */
  basicSearch() {
    this.statusSelected = [{id: 2, statusType: "New"}, {id: 3, statusType: "Pending"}];
    this.eventIdSelected = [];
    this.countrySelected = [];
    this.leadSelected = [];
    this.VOISelected = [];
    this.regionSelected = [];
    this.advancesearchfields = new LeadsAdvanceSearch(null, null, "", [], [], null, [{
      id: 2,
      statusType: "New"
    }, {id: 3, statusType: "Pending"}], [], "", [], [], 0, 10, "", "", true, "", "", [], [], "", [], false);
    this.showCriteria = [];
    this.leadList = [];
    this.normalSearch = true;
    this.list = false;
    this.advanceSearchList = false;
    this.offset = 0;
    this.advanceOffset = 0;
    //To enable/disable Export functionality
    this.leadExportStatus = false;
    if (!this.leadExportStatus) {
      //this.$j('[data-toggle="tooltip"]').tooltip("disable");
    }
    if (this.basicOffset == 0) {
      this.showBack = false;
    }
    this._leadService.getLeadSearch(this.userId, this.lastname, this.basicOffset, this.limit, this.column, this.sort, (result) => {
      //  console.log("***********************"+this.basicOffset)
      this.leadList = result.beans;
      if (this.basicOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }
      if (this.leadList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.leadList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.leadList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.leadList.length > 10) {

        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }
      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    });
  }

  /**
   * @author Pradeep
   * @description advance search for leads list
   */
  advanceSearch() {
    //   console.log("gggg"+JSON.stringify(this.advancesearchfields))

    /**
     * @author Nagendra
     * @description Used to push values to showCriteria based on value given for advance fields
     * @uses To show criteria after advance search
     * @created Date 24-10-2018
     * @modified Date 26-10-2018
     */
    this.advancesearchfields.fromDate = this.datePipe.transform(this.advancesearchfields.fromDate, "yyyy-MM-dd");
    this.advancesearchfields.toDate = this.datePipe.transform(this.advancesearchfields.toDate, "yyyy-MM-dd");
    this.advancesearchfields.submitionDate = this.datePipe.transform(this.advancesearchfields.submitionDate, "yyyy-MM-dd");
    this.showCriteria = [];
    //resetting count values
    this.statusCount = 0;
    this.eventIdCount = 0;
    this.countryCount = 0;
    this.leadCount = 0;
    this.VOICount = 0;
    this.regionCount = 0
    this.VPCount = 0;
    this.RDCount = 0
    this.WebsiteCount = 0;
    this.campaignCount = 0;
    //resetting Index values
    this.statusIndex = [];
    this.eventIdIndex = [];
    this.countryIndex = [];
    this.leadIndex = [];
    this.VOIIndex = [];
    this.regionIndex = [];
    this.VPIndex = [];
    this.websiteIndex = [];
    this.campaignIndex = [];
    //resetting filter values
    this.filterStatus = [];
    this.filterEventId = [];
    this.filterCountry = [];
    this.filterLead = [];
    this.filterVOI = [];
    this.filterRegion = [];
    this.filterVP = [];
    this.filterWebsite = [];
    this.filterCampaign = [];
    //To enable/disable Export functionality
    this.leadExportStatus = false;
    sessionStorage.setItem("pageNo","1");
    if (!this.leadExportStatus) {
      //this.$j('[data-toggle="tooltip"]').tooltip("disable");
    }
    if (this.lastname != null && this.lastname.trim() != "") {
      this.showCriteria.push({
        label: 'LastName',
        value: this.lastname
      })
    }
    if (this.advancesearchfields.firstName != null) {
      if (this.advancesearchfields.firstName.replace(/\s/g, "") != "" && this.advancesearchfields.firstName != null) {
        this.showCriteria.push({
          label: 'First Name',
          value: this.advancesearchfields.firstName
        })
      }
    }
    if (this.advancesearchfields.leadNumber != null) {
      if (this.advancesearchfields.leadNumber.replace(/\s/g, "") != "" && this.advancesearchfields.leadNumber != null) {
        this.showCriteria.push({
          label: 'Lead Number',
          value: this.advancesearchfields.leadNumber
        })
      }
    }

    if (this.RDSelected != "" && this.RDSelected != null) {
      this.advancesearchfields.fromDate = ""
      this.advancesearchfields.toDate = ""
      this.fromDate = null
      this.toDate = null
      this.showCriteria.push({
        label: 'Relative Date',
        value: this.RDSelected
      })
    }


    if (this.advancesearchfields.submitionDate != "" && this.advancesearchfields.submitionDate != null) {
      this.showCriteria.push({
        label: 'Submission Date',
        value: this.advancesearchfields.submitionDate,
      })
    }
    if (this.advancesearchfields.fromDate != "" && this.advancesearchfields.fromDate != null) {
      this.showCriteria.push({
        label: 'From Date',
        value: this.advancesearchfields.fromDate
      })
    }
    if (this.advancesearchfields.toDate != "" && this.advancesearchfields.toDate != null) {
      this.showCriteria.push({
        label: 'To Date',
        value: this.advancesearchfields.toDate
      })
    }

    //To show All value for label if select all is used
    if (this.isStatusAll == true) {
      this.showCriteria.push({
        id: 'statusAll',
        label: 'Status',
        value: 'All'
      })
    }
    if (this.isEventIdAll == true) {
      this.showCriteria.push({
        id: 'eventAll',
        label: 'Event ID',
        value: 'All'
      })
    }
    if (this.isCountryAll == true) {
      this.showCriteria.push({
        id: 'countryAll',
        label: 'Country',
        value: 'All'
      })
    }
    if (this.isLeadAll == true) {
      this.showCriteria.push({
        id: 'leadAll',
        label: 'Lead Source',
        value: 'All'
      })
    }
    if (this.isVOIAll == true) {
      this.showCriteria.push({
        id: 'VOIAll',
        label: 'Vehicle Of Interest',
        value: 'All'
      })
    }
    if (this.isRegionAll == true) {
      this.showCriteria.push({
        id: 'regionAll',
        label: 'Region',
        value: 'All'
      })
    }
    if (this.isVPAll == true) {
      this.showCriteria.push({
        id: 'VPAll',
        label: 'Vehicle Purpose',
        value: 'All'
      })
    }
    if (this.isWebsiteAll == true) {
      this.showCriteria.push({
        id: 'websiteAll',
        label: 'Website',
        value: 'All'
      })
    }
    if (this.isCampaignAll == true) {
      this.showCriteria.push({
        id: 'campaignAll',
        label: 'Campaign Name',
        value: 'All'
      })
    }

    this.advancesearchfields.statusIds = [];
    this.advancesearchfields.eventIds = [];
    this.advancesearchfields.sourceIds = [];
    this.advancesearchfields.countryIds = [];
    this.advancesearchfields.vehicleOfInterestIds = [];
    this.advancesearchfields.regionIds = []
    this.advancesearchfields.vehiclePurposeIds = [];
    this.advancesearchfields.websites = [];
    this.advancesearchfields.campaignNames = [];
    /**
     * @author Nagendra
     * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
     */
    if (Object.keys(this.statusSelected).length > 0 && this.statusSelected != undefined && this.isStatusAll != true) {
      Object.keys(this.statusSelected).map(key => (
        this.advancesearchfields.statusIds.push(
          this.statusSelected[key]['id']),
          this.showCriteria.push({
            id: this.statusSelected[key]['id'],
            label: 'Status',
            value: this.statusSelected[key]['statusType']
          })
      ));
    }
    if (Object.keys(this.eventIdSelected).length > 0 && this.eventIdSelected != undefined && this.isEventIdAll != true) {
      Object.keys(this.eventIdSelected).map(key => (
        this.advancesearchfields.eventIds.push(
          this.eventIdSelected[key]['id']),
          this.showCriteria.push({
            id: this.eventIdSelected[key]['id'],
            label: 'Event ID',
            value: this.eventIdSelected[key]['idWithDescription']
          })
      ));
    }
    if (Object.keys(this.countrySelected).length > 0 && this.countrySelected != undefined && this.isCountryAll != true) {
      Object.keys(this.countrySelected).map(key => (
        this.advancesearchfields.countryIds.push(
          this.countrySelected[key]['id']),
          this.showCriteria.push({
            id: this.countrySelected[key]['id'],
            label: 'Country',
            value: this.countrySelected[key]['namecode']
          })
      ));
    }
    if (Object.keys(this.leadSelected).length > 0 && this.leadSelected != undefined && this.isLeadAll != true) {
      Object.keys(this.leadSelected).map(key => (
        this.advancesearchfields.sourceIds.push(
          this.leadSelected[key]['id']),
          this.showCriteria.push({
            id: this.leadSelected[key]['id'],
            label: 'Lead Source',
            value: this.leadSelected[key]['sourceType']
          })
      ));
    }
    if (Object.keys(this.VOISelected).length > 0 && this.VOISelected != undefined && this.isVOIAll != true) {
      Object.keys(this.VOISelected).map(key => (
        this.advancesearchfields.vehicleOfInterestIds.push(
          this.VOISelected[key]['id']),
          this.showCriteria.push({
            id: this.VOISelected[key]['id'],
            label: 'Vehicle Of Interest',
            value: this.VOISelected[key]['makeModel']
          })
      ));
    }
    if (Object.keys(this.regionSelected).length > 0 && this.regionSelected != undefined && this.isRegionAll != true) {
      Object.keys(this.regionSelected).map(key => (
        this.advancesearchfields.regionIds.push(
          this.regionSelected[key]['id']),
          this.showCriteria.push({
            id: this.regionSelected[key]['id'],
            label: 'Region',
            value: this.regionSelected[key]['codeDescription']
          })
      ));
    }

    if (Object.keys(this.VPSelected).length > 0 && this.VPSelected != undefined && this.isVPAll != true) {
      Object.keys(this.VPSelected).map(key => (
        this.advancesearchfields.vehiclePurposeIds.push(
          this.VPSelected[key]['id']),
          this.showCriteria.push({
            id: this.VPSelected[key]['id'],
            label: 'Vehicle Purpose',
            value: this.VPSelected[key]['description']
          })
      ));
    }

    if (this.RDSelected != "" && this.RDSelected != undefined) {
      var FromDate = new Date()
      var toDate = new Date()
      if (this.RDSelected == "Last 7 Days") {
        FromDate.setDate(FromDate.getDate() - 7);
        this.advancesearchfields.toDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advancesearchfields.fromDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }
      if (this.RDSelected == "Last 30 Days") {
        FromDate.setDate(FromDate.getDate() - 30);
        this.advancesearchfields.toDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advancesearchfields.fromDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }
      if (this.RDSelected == "Last 60 Days") {
        FromDate.setDate(FromDate.getDate() - 60);
        this.advancesearchfields.toDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advancesearchfields.fromDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }

//      Object.keys(this.RDSelected).map(key => (
//        this.advancesearchfields.statusIds.push(
//          this.statusSelected[key]['id']),
//          this.showCriteria.push({
//            id: this.statusSelected[key]['id'],
//            label: 'Status',
//            value: this.statusSelected[key]['statusType']
//          })
//      ));
    }


    if (this.websiteSelected.length > 0 && this.websiteSelected != undefined && this.isWebsiteAll != true) {
      this.advancesearchfields.websites = this.websiteSelected;
      for (let i = 0; i < this.websiteSelected.length; i++) {
        this.showCriteria.push({
          label: 'Website',
          value: this.websiteSelected[i]
        })
      }
    }
    if (this.campaignSelected.length > 0 && this.campaignSelected != undefined && this.isCampaignAll != true) {
      this.advancesearchfields.campaignNames = this.campaignSelected;
      for (let i = 0; i < this.campaignSelected.length; i++) {
        this.showCriteria.push({
          label: 'Campaign Name',
          value: this.campaignSelected[i]
        })
      }
    }
    this.leadList = [];
    this.advanceSearchList = true;
    this.normalSearch = false;
    this.list = false;
    this.offset = 0;
    this.basicOffset = 0;
    if (this.advanceOffset == 0) {
      this.showBack = false;
    }
    this.showAdvanceLink = true;
    this.advancesearchfields.userId = this.userId;
    this.advancesearchfields.lastName = this.lastname;
    this.advancesearchfields.offset = this.advanceOffset;
    this.advancesearchfields.orderBy = this.column;
    this.advancesearchfields.sortBy = this.sort;
    this.advancesearchfields.isPagination = this.enablePagination;
    this.advancesearchfields.pageLimit = this.limit;

    this.noData = false;

    //counting dropdown values
    this.showCriteria.map((obj) => {
      if (obj.label == "Status") {
        this.statusCount++
      }
      if (obj.label == "Event ID") {
        this.eventIdCount++
      }
      if (obj.label == "Country") {
        this.countryCount++
      }
      if (obj.label == "Lead Source") {
        this.leadCount++
      }
      if (obj.label == "Vehicle Of Interest") {
        this.VOICount++
      }
      if (obj.label == "Region") {
        this.regionCount++
      }
      if (obj.label == "Website") {
        this.WebsiteCount++
      }
      if (obj.label == "Campaign Name") {
        this.campaignCount++
      }
    });

    //Checking index of particular label values and pushing

    if (this.statusCount > 3 && this.isStatusAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Status") {
          this.statusIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.eventIdCount > 3 && this.isEventIdAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Event ID") {
          this.eventIdIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.countryCount > 3 && this.isCountryAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Country") {
          this.countryIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.leadCount > 3 && this.isLeadAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Lead Source") {
          this.leadIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.VOICount > 3 && this.isVOIAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Vehicle Of Interest") {
          this.VOIIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.regionCount > 3 && this.isRegionAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Region") {
          this.regionIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.WebsiteCount > 3 && this.isWebsiteAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Website") {
          this.websiteIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.campaignCount > 3 && this.isCampaignAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Campaign Name") {
          this.campaignIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }

    //Removing values from Criteria and appending one value with count
    if (Object.keys(this.statusIndex).length > 3 && this.isStatusAll != true) {
      this.statusIndex.map(index => {
        this.filterStatus.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxStatus',
        label: 'Status',
        value: this.statusSelected[0].statusType + " + " + (this.statusCount - 1)
      })
    }

    if (Object.keys(this.eventIdIndex).length > 3 && this.isEventIdAll != true) {
      this.eventIdIndex.map(index => {
        this.filterEventId.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxEventId',
        label: 'Event ID',
        value: this.eventIdSelected[0].idWithDescription + " + " + (this.eventIdCount - 1)
      })
    }

    if (Object.keys(this.countryIndex).length > 3 && this.isCountryAll != true) {
      this.countryIndex.map(index => {
        this.filterCountry.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxCountry',
        label: 'Country',
        value: this.countrySelected[0].namecode + " + " + (this.countryCount - 1)
      })
    }

    if (Object.keys(this.leadIndex).length > 3 && this.isLeadAll != true) {
      this.leadIndex.map(index => {
        this.filterLead.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxLead',
        label: 'Lead Source',
        value: this.leadSelected[0].sourceType + " + " + (this.leadCount - 1)
      })
    }
    if (Object.keys(this.VOIIndex).length > 3 && this.isVOIAll != true) {
      this.VOIIndex.map(index => {
        this.filterVOI.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxVOI',
        label: 'Vehicle Of Interest',
        value: this.VOISelected[0].makeModel + " + " + (this.VOICount - 1)
      })
    }
    if (Object.keys(this.regionIndex).length > 3 && this.isRegionAll != true) {
      this.regionIndex.map(index => {
        this.filterRegion.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxRegion',
        label: 'Region',
        value: this.regionSelected[0].codeDescription + " + " + (this.regionCount - 1)
      })
    }
    if (this.websiteIndex.length > 3 && this.isWebsiteAll != true) {
      this.websiteIndex.map(index => {
        this.filterWebsite.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxWebsite',
        label: 'Website',
        value: this.websiteSelected[0] + " + " + (this.WebsiteCount - 1)
      })
    }
    if (this.campaignIndex.length > 3 && this.isCampaignAll != true) {
      this.campaignIndex.map(index => {
        this.filterCampaign.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxCampaign',
        label: 'Campaign Name',
        value: this.campaignSelected[0] + " + " + (this.campaignCount - 1)
      })
    }

    //Filtering values
    let filtered = this.showCriteria.filter(item => !this.filterStatus.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterEventId.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterCountry.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterLead.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterVOI.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterRegion.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterWebsite.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterCampaign.includes(item));
    this.showCriteria = filtered;

    this._dataService.getSearchLeadList(this.advancesearchfields, (result) => {
      this.showAdvance = false;
      this.leadList = result.beans;

      if (this.advanceOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }
      if (this.leadList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.leadList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.leadList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.leadList.length > 10) {

        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }
      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
      setTimeout(() => {
        //   console.log("%%%%%%%%" + this.leadSelected);
      }, 10000)
    })

  }

  /**
   * @author Pradeep
   * @description show and hide the date range
   */
  showdaterange(val) {
    if (val) {
      this.RDSelected = ""
      this.advancesearchfields.submitionDate = "";
      this.submissionDate = null;
      this.showsubmission = false;
      this.showsubmissionrange = true;
    } else {

      this.advancesearchfields.fromDate = "";
      this.RDSelected = ""
      this.fromDate = null;
      this.toDate = null;
      this.advancesearchfields.toDate = "";
      this.showsubmission = true;
      this.showsubmissionrange = false;
    }
  }

  /**
   * @author Pradeep
   * @description redirect to lead detail page
   */
  viewLeadsDetails(leadId) {
    //setting params based on search/sort criteria
    sessionStorage.setItem("pageNo",String(this.p));
    if (this.normalSearch == true) {
      this.normalSearchValues.lastname = this.lastname;
      this.normalSearchValues.sortBy = this.sort;
      this.normalSearchValues.orderBy = this.column;
      this.normalSearchValues.direction = this.direction;
      sessionStorage.removeItem("advanceSearch");
      sessionStorage.removeItem("advanceSearchDirection");
      sessionStorage.removeItem("advancesearchfields");
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.removeItem("leadList");
      sessionStorage.removeItem("leadListValues");
      sessionStorage.setItem("normalSearch", this.basicOffset.toString());
      sessionStorage.setItem("normalSearchValues", JSON.stringify(this.normalSearchValues));
    } else if (this.advanceSearchList == true) {
      sessionStorage.removeItem("normalSearch");
      sessionStorage.removeItem("normalSearchValues");
      sessionStorage.removeItem("leadList");
      sessionStorage.removeItem("leadListValues");
      /*if (this.advancesearchfields.submitionDate != null && this.advancesearchfields.submitionDate != "") {
        this.advancesearchfields.submitionDate = this.submissionDate.toDateString();
      }
      if (this.advancesearchfields.fromDate != null && this.advancesearchfields.fromDate != "") {
        this.advancesearchfields.fromDate = this.fromDate.toDateString();
      }
      if (this.advancesearchfields.toDate != null && this.advancesearchfields.toDate != "") {
        this.advancesearchfields.toDate = this.toDate.toDateString();
      }*/
      sessionStorage.setItem("advanceSearch", this.advanceOffset.toString());
      if (this.direction) {
        sessionStorage.setItem("advanceSearchDirection", this.direction.toString());
      }
      /**
       * @author Nagendra
       * @description Assiging local values of dropdown to session storage value (advancesearchfields)
       */
      this.advancesearchfields.statusIds = this.statusSelected;
      this.advancesearchfields.eventIds = this.eventIdSelected;
      this.advancesearchfields.sourceIds = this.leadSelected;
      this.advancesearchfields.countryIds = this.countrySelected;
      this.advancesearchfields.vehicleOfInterestIds = this.VOISelected;
      this.advancesearchfields.regionIds = this.regionSelected
      //Used for select all/de-select all boolean values
      this.selectOrDeselect = {
        'isStatusAll': this.isStatusAll,
        'isEventIdAll': this.isEventIdAll,
        'isCountryAll': this.isCountryAll,
        'isLeadAll': this.isLeadAll,
        'isVOIAll': this.isVOIAll,
        'isVPAll': this.isVPAll,
        'isWebsiteAll': this.isWebsiteAll,
        'isCampaignAll': this.isCampaignAll,
        'isRegionAll': this.isRegionAll,
      };
      sessionStorage.setItem("selectOrDeselect", JSON.stringify(this.selectOrDeselect));
      sessionStorage.setItem("advancesearchfields", JSON.stringify(this.advancesearchfields));
    } else {
      this.leadListValues.sortBy = this.sort;
      this.leadListValues.orderBy = this.column;
      this.leadListValues.direction = this.direction;
      sessionStorage.removeItem("advanceSearch");
      sessionStorage.removeItem("advanceSearchDirection");
      sessionStorage.removeItem("advancesearchfields");
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.removeItem("normalSearch");
      sessionStorage.removeItem("normalSearchValues");
      sessionStorage.setItem("leadList", this.offset.toString());
      sessionStorage.setItem("leadListValues", JSON.stringify(this.leadListValues));
    }
    this._router.navigate(['leads/detail/' + leadId])
  }

  @HostListener('document:click', ['$event'])
  clickedOutside($event) {
    const thisObj = this;
    if (!thisObj.showAdvanceLink && jQuery($event.target).closest('div.search-boxdiv').length == 0 && jQuery($event.target).closest('div.adv-topdiv').length == 0 && (jQuery($event.target).closest('a.adv-search').length == 0)) {
      if (!thisObj.datePickerClick) {
        this.showAdvance = false;
        this.showAdvanceLink = true
        //                thisObj.showadvanceSearch(false);
        //                thisObj.searchFormObj.reset();
      } else {
        thisObj.datePickerClick = false;
      }
    }
  }

  setOffset() {
    if (this.fromDate != null) {
      console.log(this.fromDate.toString())
      console.log(this.datePipe.transform( this.fromDate.toString() , "yyyy-MM-dd"))
      this.advancesearchfields.fromDate = this.datePipe.transform( this.fromDate.toString() , "yyyy-MM-dd");
    }
    if (this.toDate != null) {
      this.advancesearchfields.toDate = this.datePipe.transform( this.toDate.toString() , "yyyy-MM-dd");
    }
    if (this.submissionDate != null) {
      this.advancesearchfields.submitionDate = this.submissionDate.toString()
    }
    this.column = "";
    this.sort = "ASC";
    this.basicOffset = 0;
    this.advanceOffset = 0;
  }

  sortBy(i) {
    this.column = this.headerLeadsList[i].setting.property.slice(5);
    this.direction = !this.direction;
    if (this.direction) {
      this.sort = "ASC";
    } else {
      this.sort = "DESC";
    }
    if (this.list == true) {
      this.offset = 0;
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.getLeadList();
    } else if (this.normalSearch == true) {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.basicOffset = 0;
      this.basicSearch();
    } else {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.advanceOffset = 0;
      this.advanceSearch();
    }
  }

  /*
      * @author Ciocan Vlad
      * @uses For pagination
      * @date 22-10-2018
      * @modified date 22-10-2018
      */
  pageChanged(event) {
    if (this.pageExist != event) {
      this.pageExist = event;
      sessionStorage.setItem('pageNo', event);
      if (this.advanceSearchList == true) {
        this.offset = 0;
        this.basicOffset = 0;
        if (event >= 1) {
          this.advanceOffset = (this.pageSize * (event - 1))
          //  console.log("****************advanceSearchList******************" + this.advanceOffset);
        } else {
          this.advanceOffset = 0
        }
        this.advanceSearch();
      } else if (this.normalSearch == true) {
        this.offset = 0;
        this.advanceOffset = 0;
        if (event >= 1) {
          this.basicOffset = (this.pageSize * (event - 1))
          //console.log("****************normalSearch******************" + this.basicOffset);
        } else {
          this.basicOffset = 0
        }
        this.basicSearch();
      } else {
        if (event >= 1) {
          this.offset = (this.pageSize * (event - 1))
          //   console.log("****************withoutsearch******************" + this.offset);
        } else {
          this.offset = 0
        }
        this.getLeadList();
      }
    }
  }

  /*
  * @author Ciocan Vlad
  * @uses To change page size for list
  * @date 22-10-2018
  * @modified date 22-10-2018
  */
  changepageSize() {
    // console.log("***1111111****************************************" + this.p)
    this.limit = this.pageSize;
//      console.log("***1111111****************************************" + this.pageSize)
    if (sessionStorage.getItem("pageLimit") !== null) {
      sessionStorage.removeItem("pageLimit")
    }
    sessionStorage.setItem("pageLimit", this.limit.toString());
    this._leadService.updatePageLimit(this.userId, this.limit, result => {
//        console.log("result"+result)
    })
    if (this.advanceSearchList == true) {
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.basicSearch();
    } else {
      this.getLeadList();
    }
  }

  /*
   * @author Nagendra
   * @uses To get event id values
   * @date 22-10-2018
   * @modified date 22-10-2018
   */
  getEventId() {
    this._leadService.getEventValues(result => {
      result.forEach(obj => {
        this.eventValues.push({
          id: obj.id,
          eventId: obj.eventId,
          eventDescription: obj.eventDescription,
          idWithDescription: obj.eventId + '(' + obj.eventDescription + ')'
        })
      })
    })
  }

  /*
   * @author Nagendra
   * @uses To get VOI values
   * @date 22-10-2018
   * @modified date 23-10-2018
   */
  getVOIValues() {
    this._leadService.getVOIValues(result => {
      result.forEach(obj => {
        this.VOIWithMakeModel.push({
          id: obj.id,
          make: obj.make,
          model: obj.model,
          makeModel: obj.model + '(' + obj.make + ')'
        })
      })
    });
  }

  /**
   * @author Nagendra
   * @description SelectAll and DeSelectAll from dropdowns
   * @uses To make empty array if select all or unselect all
   * @date 24-10-2018
   * @modified date 24-10-2018
   */
  onStatusSelectAll(value) {
    this.isStatusAll = true
  }

  onStatusDeSelectAll(value) {
    this.isStatusAll = false
  }

  onEventSelectAll(value) {
    this.isEventIdAll = true
  }

  onEventDeSelectAll(value) {
    this.isEventIdAll = false
  }

  onLeadSelectAll(value) {
    this.isLeadAll = true
  }

  onLeadDeSelectAll(value) {
    this.isLeadAll = false
  }

  onCountrySelectAll(value) {
    this.isCountryAll = true
  }

  onCountryDeSelectAll(value) {
    this.isCountryAll = false
  }

  onVOISelectAll(value) {
    this.isVOIAll = true
  }

  onVOIDeSelectAll(value) {
    this.isVOIAll = false
  }

  onWebsiteSelectAll(value) {
    this.isWebsiteAll = true
  }

  onWebsiteDeSelectAll(value) {
    this.isWebsiteAll = false
  }

  onCampaignSelectAll(value) {
    this.isCampaignAll = true
  }

  onCampaignDeSelectAll(vaue) {
    this.isCampaignAll = false
  }

  onRegionSelectAll(value) {
    this.isRegionAll = true
  }

  onRegionDeSelectAll(value) {
    this.isRegionAll = false
  }

  /**
   * @author Nagendra
   * @description On select/deselect item from dropdowns
   * @date 24-10-2018
   * @modified date 24-10-2018
   */
  onStatusSelect(value) {
    this.isStatusAll = false
  }

  onStatusDeSelect(value) {
    this.isStatusAll = false
  }

  onEventSelect(value) {
    this.isEventIdAll = false
  }

  onEventDeSelect(value) {
    this.isEventIdAll = false
  }

  onLeadSelect(value) {
    this.isLeadAll = false
  }

  onLeadDeSelect(value) {
    this.isLeadAll = false
  }

  onCountrySelect(value) {
    this.isCountryAll = false
  }

  onCountryDeSelect(value) {
    this.isCountryAll = false
  }

  onVOISelect(value) {
    this.isVOIAll = false
  }

  onVOIDeSelect(value) {
    this.isVOIAll = false
  }

  onRegionSelect(value) {
    this.isRegionAll = false
  }

  onRegionDeSelect(value) {
    this.isRegionAll = false
  }

  onWebsiteSelect(value) {
    this.isWebsiteAll = false;
  }

  onWebsiteDeSelect(value) {
    this.isWebsiteAll = false;
  }

  onCampaignSelect(value) {
    this.isCampaignAll = false;
  }

  onCampaignDeSelect(value) {
    this.isCampaignAll = false;
  }

  /**
   * @author Nagendra
   * @description Used to clear criteria in advance search and make selected values to empty
   * @created Date 25-10-2018
   * @modified Date 26-10-2018
   */
  clearCriteria() {
    this.advancesearchfields = new LeadsAdvanceSearch("", null, "", [], [], null, [], [], null, [], [], 0, 10, null, null, true, "", "", [], [], "", [], false);
    this.statusSelected = [];
    this.eventIdSelected = [];
    this.countrySelected = [];
    this.leadSelected = [];
    this.VOISelected = [];
    this.regionSelected = [];
    this.websiteSelected = [];
    this.campaignSelected = [];
    this.showCriteria = [];
    this.leadExportStatus = true;
    //this.$j('[data-toggle="tooltip"]').tooltip("enable");
    sessionStorage.setItem("pageNo","1");
    this.p = 1;
  }

  /**
   * @author Nagendra
   * @description After criteria defined each value will be given with delete option from adv search
   * @created Date 25-10-2018
   * @modified Date 25-10-2018
   */
  removeFromCriteria(i) {

    const criteriaIndex = i;
    const criteriaLabel = this.showCriteria[i]['label'];
    const criteriaValue = this.showCriteria[i]['id'];
    const criteria = this.showCriteria[i]['value'];

    this.showCriteria.forEach(obj => {
      if (obj.label == "Relative Date" && criteriaLabel == "Relative Date") {
        this.RDSelected = "";
        this.advancesearchfields.fromDate = ""
        this.advancesearchfields.toDate = ""

        this.advanceSearch();
      }
      if (obj.label == "LastName" && criteriaLabel == "LastName") {
        this.lastname = "";
        this.advanceSearch();
      }
      if (obj.label == "First Name" && criteriaLabel == "First Name") {
        this.advancesearchfields.firstName = "";
        this.advanceSearch();
      }
      if (obj.label == "Lead Number" && criteriaLabel == "Lead Number") {
        this.advancesearchfields.leadNumber = "";
        this.advanceSearch();
      }
      if (obj.label == "Submission Date" && criteriaLabel == "Submission Date") {
        this.advancesearchfields.submitionDate = "";
        this.submissionDate = null;
        this.advanceSearch();
      }
      if (obj.label == "From Date" && criteriaLabel == "From Date") {
        this.advancesearchfields.fromDate = "";
        this.fromDate = null;
        this.advanceSearch();
      }
      if (obj.label == "To Date" && criteriaLabel == "To Date") {
        this.advancesearchfields.toDate = "";
        this.toDate = null;
        this.advanceSearch();
      }
      //Dropdowns
      if (obj.label == "Status" && criteriaLabel == "Status") {
        this.statusSelected.forEach((obj, index) => {
          if (this.statusSelected[index]['id'] == criteriaValue) {
            this.statusSelected.splice(index, 1);
          }
        });
        //To remove Status All
        if (obj.id == 'statusAll' && this.showCriteria[criteriaIndex]['id'] == 'statusAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isStatusAll = false;
          this.statusSelected = [];
        }
        if (criteriaValue == 'maxStatus') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.statusSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Event ID" && criteriaLabel == "Event ID") {
        this.eventIdSelected.forEach((obj, index) => {
          if (this.eventIdSelected[index]['id'] == criteriaValue) {
            this.eventIdSelected.splice(index, 1);
          }
        });
        //To remove Event Id All
        if (obj.id == 'eventAll' && this.showCriteria[criteriaIndex]['id'] == 'eventAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isEventIdAll = false;
          this.eventIdSelected = [];
        }
        if (criteriaValue == 'maxEventId') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.eventIdSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Country" && criteriaLabel == "Country") {
        this.countrySelected.forEach((obj, index) => {
          if (this.countrySelected[index]['id'] == criteriaValue) {
            this.countrySelected.splice(index, 1);
          }
        });
        //To remove Country All
        if (obj.id == 'countryAll' && this.showCriteria[criteriaIndex]['id'] == 'countryAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isCountryAll = false;
          this.countrySelected = [];
        }
        if (criteriaValue == 'maxCountry') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.countrySelected = []
        }

        this.advanceSearch();
      }
      if (obj.label == "Lead Source" && criteriaLabel == "Lead Source") {
        this.leadSelected.forEach((obj, index) => {
          if (this.leadSelected[index]['id'] == criteriaValue) {
            this.leadSelected.splice(index, 1);
          }
        });
        //To remove lead Source All
        if (obj.id == 'leadAll' && this.showCriteria[criteriaIndex]['id'] == 'leadAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isLeadAll = false;
          this.leadSelected = [];
        }
        if (criteriaValue == 'maxLead') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.leadSelected = []
        }

        this.advanceSearch();
      }
      if (obj.label == "Vehicle Of Interest" && criteriaLabel == "Vehicle Of Interest") {
        this.VOISelected.forEach((obj, index) => {
          if (this.VOISelected[index]['id'] == criteriaValue) {
            this.VOISelected.splice(index, 1);
          }
        });

        //To remove Vehicle Of Interest All
        if (obj.id == 'VOIAll' && this.showCriteria[criteriaIndex]['id'] == 'VOIAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isVOIAll = false;
          this.VOISelected = [];
        }

        if (criteriaValue == 'maxVOI') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.VOISelected = []
        }
        this.advanceSearch();
      }

      if (obj.label == "Region" && criteriaLabel == "Region") {
        this.regionSelected.forEach((obj, index) => {
          if (this.regionSelected[index]['id'] == criteriaValue) {
            this.regionSelected.splice(index, 1);
          }
        });
        if (obj.id == 'regionAll' && this.showCriteria[criteriaIndex]['id'] == 'regionAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isRegionAll = false;
          this.regionSelected = [];
        }
        if (criteriaValue == 'maxRegion') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.regionSelected = []
        }
        this.advanceSearch();
      }

      if (obj.label == "Website" && criteriaLabel == "Website") {
        this.websiteSelected.forEach((obj, index) => {
          if (this.websiteSelected[index] == criteria) {
            this.websiteSelected.splice(index, 1);
          }
        });
        //To remove Website All
        if (obj.id == 'websiteAll' && this.showCriteria[criteriaIndex]['id'] == 'websiteAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isWebsiteAll = false;
          this.websiteSelected = [];
        }
        if (criteriaValue == 'maxWebsite') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.websiteSelected = []
        }

        this.advanceSearch();
      }
      if (obj.label == "Campaign Name" && criteriaLabel == "Campaign Name") {
        for (let index = 0; index < this.campaignSelected.length; index++) {
          if (this.campaignSelected[index] == this.showCriteria[i]['value']) {
            this.campaignSelected.splice(index, 1);
          }
        }
        //To remove Website All
        if (obj.id == 'campaignAll' && this.showCriteria[criteriaIndex]['id'] == 'campaignAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isCampaignAll = false;
          this.campaignSelected = [];
        }
        if (criteriaValue == 'maxCampaign') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.campaignSelected = []
        }

        this.advanceSearch();
      }
    });
    if (Object.keys(this.showCriteria).length == 0) {
      this.showadvanceSearch(false);
      this.leadExportStatus = true;
      //this.$j('[data-toggle="tooltip"]').tooltip("enable");
    }
  }

  onSelectSubmission(event) {
    let d = new Date(Date.parse(event));
    this.advancesearchfields.submitionDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  onSelectFrom(event) {
    let d = new Date(Date.parse(event));
    this.advancesearchfields.fromDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  onSelectTo(event) {
    let d = new Date(Date.parse(event));
    this.advancesearchfields.toDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  /**
   * @author Jayasimha
   * @description Export Leads using different criteria
   * @created Date 30-01-2019
   */
  exportLeadList() {
    let newHeader = [];
    let newleads;
    let column;
    this.finalExportData = [];
    this.headerLeadsList.forEach(prefprop => {
      newHeader.push(prefprop.setting.label);
    });
    this.advancesearchfields.isPagination = false;
    if (this.normalSearch == true) {
      console.log(this.advancesearchfields);
      console.log("normal true");
      this._leadService.getLeadSearch(this.userId, this.lastname, 0, 0, this.column, this.sort, (result) => {
        result.beans.forEach(eachObj => {
          newleads = {};
          this.headerLeadsList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered" || column == "dateClosed") {
                eachObj[column] = eachObj[column] != null ? moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss") : "";
              }
              if (column == "priority_id") {
                eachObj[column] = this.isHot(eachObj["priority_id"],eachObj["submissionDate"])
              }
              newleads[prefprop.setting.label] = eachObj[column];

            } else {
              newleads[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newleads);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });
    } else if (this.advanceSearchList == true) {
      this.advancesearchfields.isPagination = false;
      this.advancesearchfields.pageLimit = 0;
      console.log(this.advancesearchfields);
      console.log("advanced true");
      this._dataService.getSearchLeadList(this.advancesearchfields, (result) => {
        console.log(result);
        result.beans.forEach(eachObj => {
          newleads = {};
          this.headerLeadsList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);

            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered" || column == "dateClosed") {
                eachObj[column] = eachObj[column] != null ? moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss") : "";
              }
              if (column == "priority_id") {
                eachObj[column] = this.isHot(eachObj["priority_id"],eachObj["submissionDate"])
              }
              newleads[prefprop.setting.label] = eachObj[column];

            } else {
              newleads[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newleads);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });

    } else {
      this._leadService.getLeadList(this.userId, this.offset, 100000, this.column, this.sort, (result) => {
        console.log(this.advancesearchfields);
        console.log("else true");
        result.beans.forEach(eachObj => {
          newleads = {};
          this.headerLeadsList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);

            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered") {
                eachObj[column] = moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss");
              }
              if (column == "priority_id") {
                eachObj[column] = this.isHot(eachObj["priority_id"],eachObj["submissionDate"])
              }
              newleads[prefprop.setting.label] = eachObj[column];

            } else {
              newleads[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newleads);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      })
    }
  }

  exportLeadsLastXDays(numberOfDays) {
    var advsf=JSON.parse(JSON.stringify(this.advancesearchfields))
    advsf.pageLimit = 0;
    advsf.isPagination = false;
    this.statusSelected = [{id: 2, statusType: "New"}];
    advsf.statusIds=[2];
    advsf.toDate = moment().format('YYYY-MM-DD');
    advsf.fromDate = moment().subtract(numberOfDays, 'd').format('YYYY-MM-DD');
    advsf.userId = this.userId;
    advsf.leadNumber = null;
    let newleads;
    let column;
    this.finalExportData = [];
    let newHeader = [
      "Submission Date", "First Name", "Last Name", "Email", "Mobile Phone",
      "Home Phone", "Address", "Vehicle", "Call to Action", "Lead Source",
      "Dealer Code", "Dealer Name", "Dealer Branch Location", "Country", "Dealer Region",
      "Website", "Campaign Name", "Event Name", "Vehicle Purpose", "Status", "Lead Number", "Comments", "Priority"
    ];
    this._dataService.getSearchLeadList(advsf, (result) => {
      result.beans.forEach(eachObj => {
        newleads = {};
        newleads["submissionDate"] = eachObj["submissionDate"] != null ? moment(eachObj["submissionDate"]).format("MM/DD/YYYY HH:mm:ss") : ""
        newleads["firstName"] = eachObj["firstName"];
        newleads["lastName"] = eachObj["lastName"];
        newleads["email"] = eachObj["email"];
        newleads["mobileNumber"] = eachObj["mobileNumber"];
        newleads["phoneNumber"] = eachObj["phoneNumber"];
        newleads["address"] = eachObj["address"];
        newleads["vehicle"] = eachObj["vehicle"];
        newleads["callToAction"] = eachObj["callToAction"];
        newleads["sourceType"] = eachObj["sourceType"];
        newleads["dealerCode"] = eachObj["dealerCode"];
        newleads["dealerName"] = eachObj["dealerName"];
        newleads["superDealerCode"] = eachObj["superDealerCode"];
        newleads["countryName"] = eachObj["countryName"];
        newleads["dealerRegionCode"] = eachObj["dealerRegionCode"];
        newleads["website"] = eachObj["website"];
        newleads["campaignName"] = eachObj["campaignName"];
        newleads["eventDescription"] = eachObj["eventDescription"];
        newleads["vehiclePurpose"] = eachObj["vehiclePurpose"];
        newleads["status"] = eachObj["status"];
        newleads["leadNumber"] = eachObj["leadNumber"];
        newleads["comments"] = eachObj["comments"];
        newleads["priority"] = this.isHot(eachObj["priority_id"],eachObj["submissionDate"])
        this.finalExportData.push(newleads);
      });
      var today: string = moment().format('D MMM YYYY HH:mm:ss');
      var options = {
        showLabels: true,
        headers: newHeader
      };
      new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
    });
  }
  isHot(l,d){
    if(l == 1 && !this.checkifOld(d)){
      return "YES"
    }
    if( l == 1 && this.checkifOld(d)){
      return "NO"
    }
    return ""
  }
  checkifOld(d){
    var then = new Date(d).getTime(),
      now  = new Date().getTime(),
      thirtyDaysInMilliseconds = 2592000000;
    if (now - then > thirtyDaysInMilliseconds) { return true }else{ return false }
  }
  getLast7Count() {


    var end = moment().format('YYYY-MM-DD');
    var start = moment().subtract(7, 'd').format('YYYY-MM-DD');
    var userId = this.userId;

    var c;
    this._dataService.getLeadCount(start, end, userId, (result) => {
      console.log(result);
      this.last7Count = result.pageCount;
      this.showTooltipLeads = false;
    });

  }

  /**
   * @author Parvathi
   * @description get website and campaign name list
   */
  getWebsiteAndCampaignNameList() {
    this._leadService.getWebsiteAndCampaignName((result) => {
      this.websites = result.websites;
      this.campaignNames = result.campaignNames
    });
  }

  /**
   * @author Vanitha
   * @description get region list
   */

  getRegionList() {
    this._leadService.getRegionList((result) => {
      result.forEach(obj => {
        this.region.push({
          id: obj.id,
          code: obj.code,
          description: obj.description,
          codeDescription: obj.code + '(' + obj.description + ')'

        })
      })
    })
  }

  initEmail() {
    /*var FromDate = new Date();
    var toDate = new Date();
    FromDate.setDate(FromDate.getDate() - 7);
    this.advancesearchfields.toDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
    this.advancesearchfields.fromDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");*/
    this.RDSelected="Last 7 Days";
    this.statusSelected = [{id: 2, statusType: "New"}];
    this._dataService.GetAjaxCall("https://fordconnect.hartehanks.com/lms/email?user="+this.userId,null, false);
    this.showCriteria.push({
      label: 'Timeframe',
      value: "Last 7 Days"
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/leads/components/lead.component.ts